"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Switch {
    handleChange(originalEvent, target) {
        if (!this.input.disabled) {
            this.emit("change", {
                originalEvent,
                value: target.value,
                checked: target.checked,
            });
        }
    }
}
module.exports = Switch;
